export default {
  open: false,
  email: '',
  success: false,
  errorMessage: '',
  loading: false,
};
